export default "__VITE_ASSET__CXIl6hSY__"